var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/call"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/call_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5158 14.95L9.66582 16.8C9.27582 17.19 8.65582 17.19 8.25582 16.81C8.14582 16.7 8.03582 16.6 7.92582 16.49C6.89582 15.45 5.96582 14.36 5.13582 13.22C4.31582 12.08 3.65582 10.94 3.17582 9.81C2.70582 8.67 2.46582 7.58 2.46582 6.54C2.46582 5.86 2.58582 5.21 2.82582 4.61C3.06582 4 3.44582 3.44 3.97582 2.94C4.61582 2.31 5.31582 2 6.05582 2C6.33582 2 6.61582 2.06 6.86582 2.18C7.12582 2.3 7.35582 2.48 7.53582 2.74L9.85582 6.01C10.0358 6.26 10.1658 6.49 10.2558 6.71C10.3458 6.92 10.3958 7.13 10.3958 7.32C10.3958 7.56 10.3258 7.8 10.1858 8.03C10.0558 8.26 9.86582 8.5 9.62582 8.74L8.86582 9.53C8.75582 9.64 8.70582 9.77 8.70582 9.93C8.70582 10.01 8.71582 10.08 8.73582 10.16C8.76582 10.24 8.79582 10.3 8.81582 10.36C8.99582 10.69 9.30582 11.12 9.74582 11.64C10.1958 12.16 10.6758 12.69 11.1958 13.22C11.2958 13.32 11.4058 13.42 11.5058 13.52C11.9058 13.91 11.9158 14.55 11.5158 14.95Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4359 18.33C22.4359 18.61 22.3859 18.9 22.2859 19.18C22.2559 19.26 22.2259 19.34 22.1859 19.42C22.0159 19.78 21.7959 20.12 21.5059 20.44C21.0159 20.98 20.4759 21.37 19.8659 21.62C19.8559 21.62 19.8459 21.63 19.8359 21.63C19.2459 21.87 18.6059 22 17.9159 22C16.8959 22 15.8059 21.76 14.6559 21.27C13.5059 20.78 12.3559 20.12 11.2159 19.29C10.8259 19 10.4359 18.71 10.0659 18.4L13.3359 15.13C13.6159 15.34 13.8659 15.5 14.0759 15.61C14.1259 15.63 14.1859 15.66 14.2559 15.69C14.3359 15.72 14.4159 15.73 14.5059 15.73C14.6759 15.73 14.8059 15.67 14.9159 15.56L15.6759 14.81C15.9259 14.56 16.1659 14.37 16.3959 14.25C16.6259 14.11 16.8559 14.04 17.1059 14.04C17.2959 14.04 17.4959 14.08 17.7159 14.17C17.9359 14.26 18.1659 14.39 18.4159 14.56L21.7259 16.91C21.9859 17.09 22.1659 17.3 22.2759 17.55C22.3759 17.8 22.4359 18.05 22.4359 18.33Z",
    fill: "#292D32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.afc645da7c55340ff95ff4fcb1002a77.svg";
export { ForwardRef as ReactComponent };